"use client"

import {createContext, ReactNode, useContext} from "react";

const FlagsContext = createContext<Record<string, boolean>>({});

interface FlagsContextProviderProps {
    flags: Record<string, boolean>;
    children: ReactNode;
}

export const FlagsContextProvider = ({ flags, children }: FlagsContextProviderProps) => {
    return (
        <FlagsContext.Provider value={flags}>
            {children}
        </FlagsContext.Provider>
    )
}

export const useFlags = () => {
    const context = useContext(FlagsContext);
    if(!context) {
        throw new Error(" useFlags must be used within a FlagsContextProvider");
    }
    return context;
}